/**
 * Soulog · Subscription plans — Monthly / Yearly toggle (sections/soulog-subscription-plans.liquid)
 *
 * Both price sets are already in the DOM; CSS shows one of them based on the section root's
 * data-billing. This script only flips that attribute and the radios' aria-checked.
 *
 * Delegated from document rather than bound per section: the theme editor re-renders a section by
 * swapping its HTML, which would drop per-element listeners; a document listener survives that.
 */
(function () {
	"use strict";

	/* The section may appear more than once on a page, and the browser runs the same external script once per tag. */
	if (window.__soulogSubsPlansLoaded) return;
	window.__soulogSubsPlansLoaded = true;

	function select(root, billing) {
		root.setAttribute("data-billing", billing);
		root.querySelectorAll("[data-ssp-billing]").forEach(function (btn) {
			btn.setAttribute("aria-checked", btn.getAttribute("data-ssp-billing") === billing ? "true" : "false");
		});
	}

	document.addEventListener("click", function (e) {
		var btn = e.target.closest && e.target.closest("[data-ssp-billing]");
		if (!btn) return;
		var root = btn.closest("[data-ssp]");
		if (root) select(root, btn.getAttribute("data-ssp-billing"));
	});

	/* Radio-group keyboard pattern: ← / → move the selection between the two options. */
	document.addEventListener("keydown", function (e) {
		if (e.key !== "ArrowLeft" && e.key !== "ArrowRight") return;
		var btn = e.target.closest && e.target.closest("[data-ssp-billing]");
		if (!btn) return;
		var root = btn.closest("[data-ssp]");
		if (!root) return;
		var buttons = Array.prototype.slice.call(root.querySelectorAll("[data-ssp-billing]"));
		var i = buttons.indexOf(btn) + (e.key === "ArrowRight" ? 1 : -1);
		var next = buttons[(i + buttons.length) % buttons.length];
		e.preventDefault();
		select(root, next.getAttribute("data-ssp-billing"));
		next.focus();
	});
})();
